import React, { useEffect } from "react";
import {
  BarChart,
  Person,
  SearchRounded,
  ShoppingCartRounded,
} from "@mui/icons-material";
import { useStateValue } from "../redux/state_provider";
const HEADER = () => {
  const [{ cart }] = useStateValue();
  useEffect(() => {
    const toggle_icon = document.querySelector(".toggle_menu");
    toggle_icon.addEventListener("click", () => {
      document.querySelector(".right_menu").classList.toggle("active");
    });
  }, []);

  return (
    <header>
      <div className="logo">FOOD</div>
      <div className="input_box">
        <SearchRounded className="search_icon" />
        <input type="text" placeholder="Search" />
      </div>

      <div className="shopping_cart">
        <ShoppingCartRounded className="cart" />

        {cart && cart.length !== 0 ? (
          <div className="cart_content">
            <p>{cart.length}</p>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="profile_container">
        <div className="img_box">
          <Person className="profile_icon" />
        </div>
        <h2 className="username">Jaran Donchaaim</h2>
      </div>

      <div className="toggle_menu">
        <BarChart className="toggle_icon" />
      </div>
    </header>
  );
};

export default HEADER;
